<template>
  <div class="d-flex align-items-center">
    <font-awesome-icon
      :icon="['fal', 'search']"
      class="search-icon"
      :class="{
        'text-blue': isFocus,
      }"
    />
    <TagInput
      v-if="searchFocusLevel === 'case'"
      :tag="caseFocusTag"
      @delete="$emit('activate-search-focus-case', false)"
    />
    <TagsInputWrapper :tags="tags" @delete="$emit('delete-tag', $event)" />
    <input
      ref="input"
      type="text"
      class="pr-2 flex-grow-1"
      :class="{ 'pl-2': tags.length }"
      :value="value"
      :placeholder="isFocus ? '' : placeholder"
      :maxlength="inputMaxLength"
      @input="updateValue"
      v-bind="$attrs"
      @keyup.esc="$emit('delete-all')"
      @focus="$emit('focus-input')"
      spellcheck="false"
      size="1"
    />
    <slot></slot>
  </div>
</template>

<script>
import TagsInputWrapper from './TagsInputWrapper';
import TagInput from './TagInput';
import { mapGetters } from 'vuex';

export default {
  inheritAttrs: false,
  name: 'mayday-web-search-input',
  components: {
    TagsInputWrapper,
    TagInput,
  },
  props: {
    value: String,
    placeholder: {
      type: String,
      default: function () {
        return this.$t('knowledge.search-admin.search-in');
      },
    },
    tags: {
      type: Array,
      default: () => [],
    },
    focusCaseId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isFocus: false,
      inputMaxLength: 500,
    };
  },
  computed: {
    caseFocusTag() {
      return {
        id: null,
        icon: ['fad', 'folder'],
        label: this.focusCaseId
          ? this.caseLabelFromNavPath(this.focusCaseId)
          : this.$t('knowledge.search-admin.current-collection'),
        color: '#0081f9',
      };
    },
    ...mapGetters('webKnowledgeModule', [
      'searchFocusLevel',
      'caseLabelFromNavPath',
    ]),
  },
  methods: {
    updateValue(evt) {
      let value = evt.target.value;
      this.$emit('input', value);
    },
    focusInput() {
      this.$nextTick(() => {
        if (this.$refs.input !== undefined) {
          this.isFocus = true;
          this.$refs.input.focus();
        }
      });
    },
    blurInput() {
      this.$nextTick(() => {
        if (this.$refs.input !== undefined) {
          this.isFocus = false;
          this.$refs.input.blur();
        }
      });
    },
    toggleFilters() {
      this.isFocus ? this.blurInput() : this.focusInput();
    },
  },
};
</script>
